/* eslint-disable react/no-array-index-key */

import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

// style
import Container, { HrefLink, MobileLink, SectionContainer, SectionTitle } from './Contact.style'

const Contact: FC = () => {
    const { t } = useTranslation()

    return (
        <Container>
            <SectionContainer>
                <SectionTitle>{t('faq.contact.germany.title')}</SectionTitle>
                <HrefLink href={`mailto:${t('faq.contact.germany.mail')}`}>{t('faq.contact.germany.mail')}</HrefLink>
                <MobileLink href={`tel:${t('faq.contact.germany.tel')}`}>{t('faq.contact.germany.tel')}</MobileLink>
                <SectionTitle>{t('faq.contact.austria.title')}</SectionTitle>
                <HrefLink href={`mailto:${t('faq.contact.austria.mail')}`}>{t('faq.contact.austria.mail')}</HrefLink>
                <MobileLink href={`tel:${t('faq.contact.austria.tel')}`}>{t('faq.contact.austria.tel')}</MobileLink>
                <SectionTitle>{t('faq.contact.switzerland.title')}</SectionTitle>
                <HrefLink href={`mailto:${t('faq.contact.switzerland.mail')}`}>
                    {t('faq.contact.switzerland.mail')}
                </HrefLink>
                <MobileLink href={`tel:${t('faq.contact.switzerland.tel')}`}>
                    {t('faq.contact.switzerland.tel')}
                </MobileLink>
            </SectionContainer>
        </Container>
    )
}

export default Contact
